import { LabourPlanStateTypes, LabourPlanActionTypes } from "./LabourPlan.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: LabourPlanStateTypes = {
  fetchAll: resetApiCallState([]),
};

const LabourPlanReducer = (
  state: LabourPlanStateTypes = INITIAL_STATE,
  action: any
): LabourPlanStateTypes => {
  switch (action.type) {
    case LabourPlanActionTypes.FETCH_ALL_LABOUR_PLAN:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case LabourPlanActionTypes.FETCH_ALL_LABOUR_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case LabourPlanActionTypes.FETCH_ALL_LABOUR_PLAN_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case LabourPlanActionTypes.FETCH_ALL_LABOUR_PLAN_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default LabourPlanReducer;
